import { render, staticRenderFns } from "./CustomFieldBadges.vue?vue&type=template&id=1cb29a19&scoped=true&"
import script from "./CustomFieldBadges.vue?vue&type=script&lang=js&"
export * from "./CustomFieldBadges.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldBadges.vue?vue&type=style&index=0&id=1cb29a19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb29a19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb29a19')) {
      api.createRecord('1cb29a19', component.options)
    } else {
      api.reload('1cb29a19', component.options)
    }
    module.hot.accept("./CustomFieldBadges.vue?vue&type=template&id=1cb29a19&scoped=true&", function () {
      api.rerender('1cb29a19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomFieldBadges.vue"
export default component.exports